import { Box } from "@chakra-ui/react"
import CallUsButton from "@components/buttons/contact/CallUs"
import WhatsappButton from "@components/buttons/contact/Whatsapp"

const FooterButtons = () => {
  return (
    <Box
      position={"fixed"}
      w={"full"}
      bottom={{ base: 24, xl: 32 }}
      zIndex={100}
    >
      <WhatsappButton />
      <CallUsButton />
    </Box>
  )
}

export default FooterButtons
